export const SET_SEARCH_FILTER = 'SET_SEARCH_FILTER';
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
export const SET_COUNT = 'SET_COUNT';
export const APPEND_RESULT = 'APPEND_RESULT';
export const RESET_SEARCH_FILTER = 'RESET_SEARCH_FILTER';



// WEBPACK FOOTER //
// ./src/screens/Search/store/types.js